import { Fl44Purchases } from '@/services/backend/products/fl44/purchases';
import { Fl44Contracts } from '@/services/backend/products/fl44/contracts';
import { Fl44Notices } from '@/services/backend/products/fl44/notices';

export default {
    purchases: new Fl44Purchases(),
    contracts: new Fl44Contracts(),
    notices: new Fl44Notices()
};
